<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <PageHeader media full>
      <TextHeading variant="subtitle" color="white" class="media-centre__subtitle">Morrisons News</TextHeading>
      <TextHeading variant="lg" color="white" block>Archived Releases</TextHeading>
    </PageHeader>
    <PageGrid>
      <PageMain>
        <ArchiveNav/>
        <PageSection>
          <GridRow cols="3">
            <GridCol>
              <CardArticle
                title="We are proud of all our fresh fish and seafood sold in our stores and café."
                image="carrier-bags.jpg"
                date="01 Jan 2019"
              />
            </GridCol>
            <GridCol>
              <CardArticle
                title="Morrisons trials first plastic deposit return scheme in its supermarket."
                image="man-fish.jpg"
                date="12 Dec 2018"
              />
            </GridCol>
            <GridCol>
              <CardArticle
                title="Morrisons trials first plastic deposit return scheme in its supermarket."
                image="farmer.jpg"
                date="30 Aug 2018"
              />
            </GridCol>
            <GridCol>
              <CardArticle
                title="We are proud of all our fresh fish and seafood sold in our stores and café."
                image="carrier-bags.jpg"
                date="01 Jan 2019"
              />
            </GridCol>
            <GridCol>
              <CardArticle
                title="Morrisons trials first plastic deposit return scheme in its supermarket."
                image="man-fish.jpg"
                date="12 Dec 2018"
              />
            </GridCol>
            <GridCol>
              <CardArticle
                title="Morrisons trials first plastic deposit return scheme in its supermarket."
                image="farmer.jpg"
                date="30 Aug 2018"
              />
            </GridCol>
          </GridRow>
        </PageSection>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import TheFooter from '../components/TheFooter.vue'
import CardArticle from '../components/CardArticle.vue'
import GridCol from '../elements/GridCol.vue'
import GridRow from '../elements/GridRow.vue'
import PageSection from '../elements/PageSection.vue'
import ArchiveNav from '../components/ArchiveNav.vue'
import PageMain from '../elements/PageMain.vue'
import PageGrid from '../elements/PageGrid.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeader from '../components/PageHeader.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
export default {
  name: 'ArchivedReleases',
  components: {
    TheHeader,
    BreadcrumbBar,
    PageHeader,
    TextHeading,
    PageGrid,
    PageMain,
    ArchiveNav,
    PageSection,
    GridRow,
    GridCol,
    CardArticle,
    TheFooter
  },
  props: {
    linkHref: {
      type: String,
      default: null
    }
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>
<style lang="postcss">
.media-centre__subtitle {
  @apply font-normal opacity-50;
}
</style>